import { ActivityBuiltInCard } from './ActivityBuiltInCard';
import { JobBuiltInCard } from './JobBuiltInCard';
import { JobLineBuiltInCard } from './JobLineBuiltInCard';
import { OpportunityBuiltInCard } from './OpportunityBuiltInCard';

// Keys are the contract with the backend IBuiltInWorkflowCardResolver implementations.
const registry = {
  'builtin.job': JobBuiltInCard,
  'builtin.activity': ActivityBuiltInCard,
  'builtin.jobline': JobLineBuiltInCard,
  'builtin.opportunity': OpportunityBuiltInCard,
};

export const getBuiltInWorkflowCard = (key) => registry[(key ?? '').toString().toLowerCase()] ?? null;

export const parseBuiltInCardData = (json) => {
  if (!json) return null;
  try {
    const parsed = JSON.parse(json);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};
